import { KomaMediumTypeComboBoxModel } from '../koma-medium-type-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 媒体区分リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetMediumListKomaFlagService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMediumListKomaFlagService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KomaMediumTypeComboBoxModel;
  private orderCode: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumListKomaFlagService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KomaMediumTypeComboBoxModel} model
   * @param {string} orderCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetMediumListKomaFlagService
   */
  execute(model: KomaMediumTypeComboBoxModel, orderCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.successFunc = successFunc;
    this.send('KYMW02GetMediumListKomaFlag', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMediumListKomaFlagService
   */
  success(data: any) {
    this.model.updateMediumList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
